<div>
  <div class="modal-header">
    <h4 class="modal-title" translate>
      page.commissions.edit.modals.echantillons.title
    </h4>
  </div>

  <ul ngbNav class="nav-tabs" #nav="ngbNav" [(activeId)]="activeTabId">
    <li ngbNavItem="tab-echantillons">
      <a ngbNavLink><span translate>page.commissions.edit.modals.echantillons.tab.echantillons</span></a>
      <ng-template ngbNavContent><ng-container *ngTemplateOutlet="tabEchantillons"></ng-container></ng-template>
    </li>
    <li ngbNavItem="tab-leurre">
      <a ngbNavLink><span translate>page.commissions.edit.modals.echantillons.tab.leurre</span></a>
      <ng-template ngbNavContent><ng-container *ngTemplateOutlet="tabLeurre"></ng-container></ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav" class="mt-3"></div>
</div>

<!-- echantillons  -->
<ng-template #tabEchantillons>
    <div class="modal-body" *ngIf="loaded">
      <div class="row">

      <div class="col">
        <app-search-bar [(value)]="searchString" *ngIf="items.length > 0"></app-search-bar>
      </div>
      <div class="col">
        <div class="">
          <label class="form-label">
            <input id="radio1" name="statut" type="radio" class="me-1"
            (click)="changeStatut(false)" (keydown.enter)="changeStatut(false)" [value]="false" [(ngModel)]="statutAPreleve" />
            <span translate>page.commissions.edit.modals.echantillons.form_leurre.preleve</span>
          </label>
          <label class="form-label">
            <input id="radio2" name="statut" type="radio" class="ms-5 me-1"
            (click)="changeStatut(true)" (keydown.enter)="changeStatut(true)" [value]="true" [(ngModel)]="statutAPreleve" />
            <span translate>page.commissions.edit.modals.echantillons.form_leurre.aprelever</span>
          </label>
        </div>
      </div>
      </div>
      <table class="table" aria-label="Liste des échantillons à affecter" *ngIf="items.length > 0; else aucunJure">
        <thead>
          <tr>
            <th (click)="setOrder('item.produit.libelleCahier')" (keydown.enter)="setOrder('item.produit.libelleCahier')" class="sortable">{{ 'page.commissions.edit.modals.echantillons.table.header.cahier' | translate }}<fa-icon [icon]="getIcon('item.produit.libelleCahier')"></fa-icon></th>
            <th (click)="setOrder('item.produit.libelle')" (keydown.enter)="setOrder('item.produit.libelle')" class="sortable">{{ 'page.commissions.edit.modals.echantillons.table.header.produit' | translate }}<fa-icon [icon]="getIcon('item.produit.libelle')"></fa-icon></th>
            <th (click)="setOrder('item.millesime')" (keydown.enter)="setOrder('item.millesime')" class="sortable">{{ 'page.commissions.edit.modals.echantillons.table.header.millesime' | translate }}<fa-icon [icon]="getIcon('item.millesime')"></fa-icon></th>
            <th (click)="setOrder('item.operateur.siret')" (keydown.enter)="setOrder('item.operateur.siret')" class="sortable">{{ 'page.commissions.edit.modals.echantillons.table.header.operateur' | translate }}<fa-icon [icon]="getIcon('item.operateur.siret')"></fa-icon></th>
            <th (click)="setOrder('item.datePrelevement')" (keydown.enter)="setOrder('item.datePrelevement')" class="sortable">{{ 'page.commissions.edit.modals.echantillons.table.header.datePrelevement' | translate }}<fa-icon [icon]="getIcon('item.datePrelevement')"></fa-icon></th>
            <th (click)="setOrder('item.volume')" (keydown.enter)="setOrder('item.volume')" class="sortable">{{ 'page.commissions.edit.modals.echantillons.table.header.volume' | translate }}<fa-icon [icon]="getIcon('item.volume')"></fa-icon></th>
            <th (click)="setOrder('item.logement')" (keydown.enter)="setOrder('item.logement')" class="sortable">{{ 'page.commissions.edit.modals.echantillons.table.header.logement' | translate }}<fa-icon [icon]="getIcon('item.logement')"></fa-icon></th>
            <th (click)="setOrder('item.expertise')" (keydown.enter)="setOrder('item.expertise')" class="sortable">{{ 'page.commissions.edit.modals.echantillons.table.header.expertise' | translate }}<fa-icon [icon]="getIcon('item.expertise')"></fa-icon></th>
          </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of items | filter : '*': searchString | orderBy:order.property:order.reverse:true" [ngClass]="{'selected':item.selected, 'disabled':item.disabled}" (click)="toggleSelectionItem(item)">
                <td>{{item.item.produit?.libelleCahier}}</td>
                <td>{{item.item.produit?.libelle}}</td>
                <td>{{item.item.millesime}}</td>
                <td>{{item.item.operateur?.siret}} - {{item.item.operateur?.raisonSociale}}</td>
                <td>{{item.item.datePrelevement | date:'shortDate' }}</td>
                <td>{{item.item.volume}}</td>
                <td>{{item.item.logement}}</td>
                <td>{{item.item.expertise}}/{{item.item.passage}}</td>
              </tr>
            </tbody>
          </table>
      </div>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" (click)="cancel()" translate>label.annuler</button>
        <button type="submit" class="btn btn-primary" (click)="submit()" [disabled]="selectedItems.length === 0" [translateParams]="{nb:selectedItems.length}" translate>page.commissions.edit.modals.echantillons.valider</button>
      </div>
</ng-template>
<!--  -->

<!-- leurre  -->
<ng-template #tabLeurre>
  <form [formGroup]="formGroupLeurre" #form="ngForm" (submit)="submitFormEchantillon()" novalidate>
    <div class="modal-body" *ngIf="loaded">
      <div class="mb-3">
        <label class="form-label" translate>page.commissions.edit.modals.echantillons.form_leurre.label.millesime</label>
        <input type="number" formControlName="millesime" [ngClass]="{'is-invalid': form.submitted && getFormField('millesime').invalid}" class="form-control"/>
      </div>

        <div class="mb-3">
          <label class="form-label" translate>page.commissions.edit.modals.echantillons.form_leurre.label.produit</label>
          <select formControlName="produit" [ngClass]="{'is-invalid': form.submitted && getFormField('produit').invalid}" class="form-select">
            <option *ngFor="let produit of produits" [ngValue]="produit">{{produit.libelle}}</option>
          </select>
        </div>

        <div class="mb-3">
          <label class="form-label" translate>page.commissions.edit.modals.echantillons.form_leurre.label.conditionnement</label>
          <select formControlName="conditionnement" [ngClass]="{'is-invalid': form.submitted && getFormField('conditionnement').invalid}" class="form-select">
            <option *ngFor="let conditionnement of conditionnements" [ngValue]="conditionnement">{{conditionnement.libelle}}</option>
          </select>
        </div>

        <div class="mb-3">
          <label class="form-label" translate>page.commissions.edit.modals.echantillons.form_leurre.label.type</label>
          <select formControlName="type" [ngClass]="{'is-invalid': form.submitted && getFormField('type').invalid}" class="form-select">
            <option *ngFor="let type of typesLeurre" [ngValue]="type">{{type.libelle}}</option>
          </select>
        </div>

        <div class="mb-3">
          <label class="form-label" translate>page.commissions.edit.modals.echantillons.form_leurre.label.defauts</label>
          <app-multiselect id="select-defauts" maxWidth="initial" bindLabel="libelle" controlName="defauts" [items]="defauts" [ngClass]="{'is-invalid': form.submitted && getFormField('defauts').invalid}"></app-multiselect>
        </div>
      </div>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" (click)="cancel()" translate>label.annuler</button>
        <button type="submit" class="btn btn-primary" translate>page.commissions.edit.modals.echantillons.form_leurre.creer_leurre</button>
      </div>
    </form>
  </ng-template>
<!--  -->

<ng-template #aucunJure>
    <div translate>page.commissions.edit.modals.echantillons.table.aucun_echantillon</div>
</ng-template>
